import moment from 'moment-timezone'
import { strftimeToMomentFormat } from '@calendly/booking-kit/services/time_format'

import { i18n } from 'locales'

const formatTime = (timeMoment, notation = '12h') => {
  if (notation === '12h') {
    return timeMoment.format('h:mma')
  }
  return timeMoment.format('HH:mm')
}

export const formatDate = (time, format, locale) => {
  const momentFormat = strftimeToMomentFormat(format || i18n.t('time.formats.date_full'))
  const timeMoment = moment.isMoment(time) ? time.clone() : moment(time)
  // Ensure locale is set for proper formatting
  const currentLocale = locale || i18n.locale
  return timeMoment.locale(currentLocale || moment.locale()).format(momentFormat)
}

export const buildSpot = (startTime, duration, timezone) => {
  startTime = moment.tz(startTime, timezone)
  return {
    start_time: startTime,
    end_time: startTime.clone().add(duration, 'minute')
  }
}

export const formatEventTime = (spot, notation) => {
  const startDate = formatDate(spot.start_time)
  const startTime = formatTime(spot.start_time, notation)
  const endTime = formatTime(spot.end_time, notation)
  return `${startTime} - ${endTime},\n ${startDate}`
}

export const formatEventTimeToDisplay = (spot, notation) => {
  const startTime = formatTime(spot.start_time, notation)
  const endTime = formatTime(spot.end_time, notation)
  return `${startTime} - ${endTime}`
}
